export default "__VITE_ASSET__CmO03AzG__"